import React from 'react'
import { Link } from 'react-router-dom'

export default function Lemon() {
  return <>
     <div className="container-fluid bg-primary py-5 bg-prd8 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Lemons</h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Lemons</Link>
          </div>
        </div>
      </div>
    </div>


    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Lemons</h2>
        <h5 className='text-muted'> Lemons are citrus fruits known for their bright yellow color,sour taste, and aromatic peel.<br />
          They belong to the family and are cultivated in many parts of the world.
        </h5>
      </div>
 
      <h2 className='text-primary my-3'>Varieties</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Adalia.</h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Yorica A
          </h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Bergamot</h5>
        </li>

      </ul>
      <h2 className='text-primary my-3'>Packing</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>15 kg net weight, 16 kg gross weight – standard carton
          </h5>
        </li>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Or plastic box </h5>
        </li>
      </ul>
  
      <hr />
      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Size:</h5>
        <h5 className=' mt-3'> (72 - 80 - 88 - 100 - 113 - 125 - 138)</h5>
      </div>
      <hr />
      <hr />
  
      <h2 className='text-primary my-3'>Season:</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>-In Egypt, typically run from November to March. 
          </h5>
        </li>
   

      </ul>
      <hr />
      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
